import { useInView } from '../hooks/useInView';

/**
 * Fades and lifts its content in the first time it scrolls into view (the
 * `.rv` → `.rv.in` transition in PosLanding.css).
 *
 * @param {object} props
 * @param {keyof JSX.IntrinsicElements} [props.as] - the element to render
 * @param {string} [props.className] - extra classes
 * @param {number} [props.delay] - ms, staggers neighbours
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
function PosLandingReveal({ as: Tag = 'div', className = '', delay = 0, children }) {
  const [ref, seen] = useInView({ threshold: 0.15, rootMargin: '0px 0px -40px' });
  return (
    <Tag ref={ref} className={`rv${seen ? ' in' : ''}${className ? ` ${className}` : ''}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </Tag>
  );
}

export default PosLandingReveal;
